export default __webpack_public_path__ + "static/media/VL-MC3000BX-1.60c445d1.jpg";